/**
Project: Operator Connect (c)
Title: Request Util 
Description: Helper class with functions for Request 
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import api from "../helpers/api-services";
import TokenUtil from "./token-util";

class RequestUtil {
  // Set the Request Headers
  static setRequestHeaders() {
    api.defaults.baseURL =
      process.env.REACT_APP_SIPPIO_OPERATOR_CONNECT_API_URL;
    api.defaults.headers.common["Content-Type"] = "application/json";
    api.defaults.headers.common["Accept"] =
      "application/json, text/plain, text/csv, application/octet-stream, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

    const sippioAccessToken = TokenUtil.getIdentitySippioAccessToken();
    if (sippioAccessToken) {
      // Apply authorization token to every request if logged in
      api.defaults.headers.common["Authorization"] = sippioAccessToken;
    } else {
      // Delete auth header
      delete api.defaults.headers.common["Authorization"];
    }
  }
}

export default RequestUtil;
